import React, { useState, useEffect } from "react";
import { getAccountStatementAPI } from "../service/AuthService";
import moment from "moment";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import dayjs from "dayjs";



export default function AccountStatement() {
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [payload, setPayload] = React.useState({
    startDate: moment().subtract(1, "day").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    type: "BALANCE_REPORT",
  });
  const [refs, setRefs] = React.useState({
    startDate: React.createRef(),
    endDate: React.createRef(),
  });
  const getAccountStatement = async () => {
    const { response } = await getAccountStatementAPI({
      ...payload,
      startDate: new Date(payload.startDate).toISOString(),
      endDate: new Date(payload.endDate).toISOString(),
    });
    if (response) {
      let res = response;
      res.slice(page.page - 1, page.pageSize);
      setPage({
        ...page,
        total: response.length,
      });
      setData(res);
    }
  };
  useEffect(() => {
    getAccountStatement();
  }, []);
  return (
    <app-account-statement
      _nghost-ng-c485763188=""
      className="ng-star-inserted"
    >
      <div _ngcontent-ng-c485763188="" className="cardMain">
        <div _ngcontent-ng-c485763188="" className="row">
          <div
            _ngcontent-ng-c485763188=""
            className="col-sm-12 col-md-12 p-mobile-1"
          >
            <div
              _ngcontent-ng-c485763188=""
              className="card card-report card-accent-primary"
            >
              <div
                _ngcontent-ng-c485763188=""
                className="card-body row p-0 mb-2"
              >
                <div
                  _ngcontent-ng-c485763188=""
                  className="col-md-12 betHistory"
                >
                  <div _ngcontent-ng-c485763188="" className="row">
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-12 mb-2 slct-dat"
                    >
                      <div _ngcontent-ng-c485763188="" className="form-group">
                        <select
                          _ngcontent-ng-c485763188=""
                          id="dataSourceSelect"
                          className="form-control custom-select ng-untouched ng-pristine ng-valid"
                        >
                          <option _ngcontent-ng-c485763188="" value="">
                            Data Source
                          </option>
                          <option _ngcontent-ng-c485763188="" value="LIVE">
                            LIVE DATA
                          </option>
                          <option _ngcontent-ng-c485763188="" value="BACKUP">
                            BACKUP DATA
                          </option>
                          <option _ngcontent-ng-c485763188="" value="OLD">
                            OLD DATA
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-12 mb-2 pick-date-slct"
                    >
                      <div
                        _ngcontent-ng-c485763188=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c485763188=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <DatePicker
                                  className="custom_date_react"
                                  onChange={(date) =>
                                    setPayload({
                                      ...payload,
                                      startDate: date ? moment(date).format("YYYY-MM-DD") : null,
                                    })
                                  }
                                  maxDate={new Date()}
                                  format="y-MM-dd"
                                  value={payload.startDate ? dayjs(payload.startDate) : null}
                                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                                />
                                
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      refs.startDate.current.click();
                                    }}
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>

                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-12 mb-2 pick-date-slct-two"
                    >
                      <div
                        _ngcontent-ng-c485763188=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c485763188=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <DatePicker
                                  onChange={(date) =>
                                    setPayload({
                                      ...payload,
                                      endDate: date ? moment(date).format("YYYY-MM-DD") : null,
                                    })
                                  }
                                  className="custom_date_react"
                                  format="y-MM-dd"
                                  minDate={payload?.startDate ? dayjs(payload.startDate).toDate() : new Date()}
                                  maxDate={new Date()}
                                  value={payload.endDate ? dayjs(payload.endDate) : null}
                                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                                />
                                
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    onClick={getAccountStatement}
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>
                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-6 button-con"
                    >
                      <button
                        _ngcontent-ng-c485763188=""
                        type="button"
                        className="btn btn-primary btnn"
                        onClick={getAccountStatement}
                      >
                        <strong _ngcontent-ng-c485763188="">
                          Get Statement
                        </strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div _ngcontent-ng-c485763188="" className="row">
          <div
            _ngcontent-ng-c485763188=""
            className="col-sm-12 col-md-12 p-mobile-1"
          >
            <div
              _ngcontent-ng-c485763188=""
              className="card card-accent-primary"
            >
              <div
                _ngcontent-ng-c485763188=""
                className="card-header account-detail-head"
              >
                Account Statement
              </div>
              <div
                _ngcontent-ng-c485763188=""
                className="card-body account-stat-body"
              >
                <div _ngcontent-ng-c485763188="" className="row">
                  <div
                    _ngcontent-ng-c485763188=""
                    className="col-md-12 p-mobile-0"
                  >
                    <div
                      id="DataTables_Table_1_wrapper"
                      className="dataTables_wrapper"
                    >
                      <div
                        className="dataTables_length"
                        id="DataTables_Table_1_length"
                      >
                        <label>
                          Show{" "}
                          <select
                            name="DataTables_Table_1_length"
                            aria-controls="DataTables_Table_1"
                            className=""
                            onChange={(e) => {
                              setPage({
                                ...page,
                                pageSize: e.target.value,
                              });
                            }}
                            value={page.pageSize}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                      <table
                        _ngcontent-ng-c485763188=""
                        datatable=""
                        className="row-border no-footer table table-hover table-responsive innertable dataTable"
                        id="DataTables_Table_1"
                        aria-describedby="DataTables_Table_1_info"
                      >
                        <thead _ngcontent-ng-c485763188="">
                          <tr _ngcontent-ng-c485763188="">
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting sorting_desc"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="descending"
                              aria-label="Date/Time: activate to sort column ascending"
                            >
                              Date/Time
                            </th>
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Deposit: activate to sort column ascending"
                            >
                              Deposit
                            </th>
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Withdraw: activate to sort column ascending"
                            >
                              Withdraw
                            </th>
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Balance: activate to sort column ascending"
                            >
                              Balance
                            </th>
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Remarks: activate to sort column ascending"
                            >
                              Remarks
                            </th>
                            <th
                              _ngcontent-ng-c485763188=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_1"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="From/To: activate to sort column ascending"
                            >
                              From/To
                            </th>
                          </tr>
                        </thead>
                        <tbody _ngcontent-ng-c485763188="">
                          {data
                            ?.sort(
                              (a, b) =>
                                new Date(b.createdAt) - new Date(a.createdAt)
                            )
                            .map((item, index) => (
                              <tr
                                _ngcontent-ng-c485763188=""
                                className="odd"
                                role="row"
                              >
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {moment(item.createdAt + "Z").format(
                                    "DD-MM-YYYY HH:mm"
                                  )}
                                </td>
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {item.creditInfo}
                                </td>
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {item.debitInfo}
                                </td>
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {item.currentBalance?.toFixed(2)}
                                </td>
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {item.comment}
                                </td>
                                <td
                                  _ngcontent-ng-c485763188=""
                                  className="text-center"
                                >
                                  {item.comment}
                                </td>
                              </tr>
                            ))}
                          {data.length == 0 && (
                            <tr className="odd">
                              <td
                                valign="top"
                                colSpan={6}
                                className="dataTables_empty"
                              >
                                No data available in table
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot
                          _ngcontent-ng-c485763188=""
                          className="ng-star-inserted"
                        >
                          {data?.length == 0 && (
                            <tr _ngcontent-ng-c485763188="">
                              <td
                                _ngcontent-ng-c485763188=""
                                colSpan={6}
                                style={{ textAlign: "center" }}
                                rowSpan={1}
                              >
                                No data!
                              </td>
                            </tr>
                          )}
                        </tfoot>
                        {/**/}
                      </table>
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_1_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {page.page} to {page.pageSize} of {page.total}{" "}
                        entries
                      </div>
                      <div
                        className="dataTables_paginate paging_full_numbers"
                        id="DataTables_Table_1_paginate"
                      >
                        <a
                          className="paginate_button first disabled"
                          aria-controls="DataTables_Table_1"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="first"
                          tabIndex={-1}
                          onClick={() => {
                            setPage({
                              ...page,
                              page: 1,
                            });
                          }}
                          id="DataTables_Table_1_first"
                        >
                          First
                        </a>
                        <a
                          className="paginate_button previous disabled"
                          aria-controls="DataTables_Table_1"
                          aria-disabled="true"
                          role="link"
                          onClick={() => {
                            if (page.page > 1)
                              setPage({
                                ...page,
                                page: page.page - 1,
                              });
                          }}
                          data-dt-idx="previous"
                          tabIndex={-1}
                          id="DataTables_Table_1_previous"
                        >
                          Previous
                        </a>
                        <span />
                        <a
                          className="paginate_button next disabled"
                          aria-controls="DataTables_Table_1"
                          aria-disabled="true"
                          role="link"
                          onClick={() => {
                            if (
                              page.page < page.total &&
                              page.page < page.pageSize
                            )
                              setPage({
                                ...page,
                                page: page.page + 1,
                              });
                          }}
                          data-dt-idx="next"
                          tabIndex={-1}
                          id="DataTables_Table_1_next"
                        >
                          Next
                        </a>
                        <a
                          className="paginate_button last disabled"
                          aria-controls="DataTables_Table_1"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="last"
                          tabIndex={-1}
                          onClick={() => {
                            setPage({
                              ...page,
                              page: Math.ceil(page.total / page.pageSize),
                            });
                          }}
                          id="DataTables_Table_1_last"
                        >
                          Last
                        </a>
                      </div>
                    </div>
                    {/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-account-statement>
  );
}
